import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AccordionButtonStyle, AccordionDisplay } from './FilterStyle';
import { pushOperationString, pushSelectedType, setSearchString } from '../../slices/RiskFilterSlice';
import ButtonGroup from '@material-ui/core/ButtonGroup';

const OperationCard = ({
  setInputText
}) => {
  const operationsNamesArray = useSelector(state => state.operationsSlice.operationsNamesArray);
  const filterQueryArray = useSelector(state => state.riskFilterSlice.filterQueryArray);
  const dispatch = useDispatch();
  return /*#__PURE__*/React.createElement(AccordionDisplay, null, operationsNamesArray.map((operation, index) => {
    return /*#__PURE__*/React.createElement(ButtonGroup, {
      key: index,
      variant: "light"
    }, /*#__PURE__*/React.createElement(AccordionButtonStyle, {
      key: index,
      name: operation,
      value: operation,
      onClick: e => {
        let selectedOperation = e.currentTarget.value;
        dispatch(pushOperationString(selectedOperation));
        let selectedRecord = {};
        selectedRecord['recordType'] = selectedOperation;
        selectedRecord['keyName'] = filterQueryArray[0];
        dispatch(pushSelectedType(selectedRecord));
        dispatch(setSearchString(''));
        setInputText('');
      }
    }, operation));
  }));
};

export default OperationCard;